import { connect } from 'react-redux'
import { setMenuActiveState } from 'store/menu-state/actions'
import { setMenuSelectedState } from 'store/menu-selected/actions'
import permissionActions from 'store/permissions/actions'
import featuresActions from 'store/features/actions'
import { setSelectedReport } from '../../store/reports/actions'
import HeaderComponent from './Header'

const mapStateToProps = state => ({
  menuState: state.menuState,
  menuSelectedState: state.menuSelectedState,
  permissions: state.permissions,
  features: state.features
})

const mapDispatchToProps = dispatch => ({
  setMenuActiveState: (state) => {
    dispatch(setMenuActiveState(state))
  },
  setMenuSelectedState: (state) => {
    dispatch(setMenuSelectedState(state))
  },
  getPermissions: () => {
    dispatch({ type: permissionActions.fetchPermissions })
  },
  getFeatures: () => {
    dispatch({ type: featuresActions.fetchFeatures })
  },
  setSelectedReportType: (reportType) => {
    dispatch(setSelectedReport(reportType))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComponent)



// WEBPACK FOOTER //
// ./src/components/Header/index.js